import { RouteObject } from 'react-router-dom';

import { CompanyProfile } from './CompanyProfile';

export const companyProfileRoute: RouteObject = {
  path: 'company-profile',
  element: <CompanyProfile />,
};
